<template>
	<ui-dialog
		ref="dialog"
		:title="`${mode === 'add' ? 'Add' : 'Edit'} favorite - ${sipUri}`"
		closable
	>
		<ui-form
			:valid.sync="formValid"
			@submit="update(sipUri, {
				name: contactTitle,
				...pinCode && { dtmf: pinCode },
				...pinCode && pinDelay && { dtmf_delay: pinDelay },
				favorite: true
			})"
		>
			<div class="ui-dialog__content__body">
				<ui-input
					v-model="contactTitle"
					label="Favorite title"
				/>
				<pin-input
					v-model="pinCode"
					:pin-delay.sync="pinDelay"
					class="ui-dialog__content__body__pin-input"
				/>
			</div>
			<ui-dialog-footer>
				<ui-button
					v-if="mode === 'edit'"
					:disabled="isFetching"
					secondary
					text="Remove"
					tooltip="Remove favorite"
					@click="remove(sipUri)"
				/>
				<ui-button
					:disabled="isFetching || !formValid"
					:text="mode === 'add' ? 'Add' : 'Update'"
					:tooltip="mode === 'add' ? 'Add favorite' : 'Update favorite'"
					primary
					type="submit"
				/>
			</ui-dialog-footer>
		</ui-form>
	</ui-dialog>
</template>

<script>
import PinInput from "PinInput";
import UiButton from "lib/components/ui/Button";
import UiDialog from "lib/components/ui/Dialog";
import UiDialogFooter from "lib/components/ui/DialogFooter";
import UiForm from "lib/components/ui/Form";
import UiInput from "lib/components/ui/Input";
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";

export default {
	name: "SessionFavoriteDialog",
	components: {
		PinInput,
		UiButton,
		UiDialog,
		UiDialogFooter,
		UiForm,
		UiInput
	},
	props: {
		userId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			contactTitle: "",
			formValid: false,
			isFetching: false,
			mode: "add",
			pinCode: null,
			pinDelay: 5,
			sipUri: null
		};
	},
	mounted() {
		this.open = (contact) => {
			this.mode = contact.favorite ? "edit" : "add";
			this.contactTitle = contact.name;
			this.sipUri = contact.uri;
			this.pinCode = contact.dtmf;
			this.pinDelay = contact.dtmf_delay || 5;

			this.$refs.dialog.open();
		};

		$bus.$on("_session/ui/FavoriteDialog.open", this.open);
	},
	beforeDestroy() {
		$bus.$off("_session/ui/FavoriteDialog.open", this.open);
	},
	methods: {
		remove(sipUri) {
			const parameters = { favorite: false };

			this.isFetching = true;

			http.patch(`/api/v2/user/${this.userId}/contact/${encodeURIComponent(sipUri)}`, parameters)
			.then(() => {
				this.$emit("remove");
				this.$refs.dialog.close();
			})
			.catch((error) => {
				alert.error("Unable to remove favorite", error.response);
			})
			.finally(() => {
				this.isFetching = false;
			});
		},
		update(sipUri, parameters) {
			this.isFetching = true;

			http.post(`/api/v2/user/${this.userId}/contact/${encodeURIComponent(sipUri)}`, parameters)
			.then(() => {
				this.$emit("update");
				this.$refs.dialog.close();
			})
			.catch((error) => {
				alert.error("Unable to add/update favorite", error.response);
			})
			.finally(() => {
				this.isFetching = false;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.ui-dialog__content__body {
	display: flex;
	.ui-dialog__content__body__pin-input {
		margin-left: 16px;
		max-width: 248px;
		/deep/ input {
			width: 100%;
		}
	}
}
</style>
